import { FC } from "react"
import { useNavigate } from "react-router-dom"
import { useFindRateflowsQuery } from "../../../../redux/queries"
import { useBrandSearchParam } from "../../../hooks"
import { Brand } from "../../../../types"
import ConfigListShell from "../config-list-shell"
import RateflowTable from "./table"

interface Props {
  brands: Brand[]
}

const ConfigRateflow: FC<Props> = ({ brands }) => {
  const navigate = useNavigate()
  const [selectedBrandId, setSelectedBrandId] = useBrandSearchParam()

  const { data: rateflows, isFetching } = useFindRateflowsQuery(
    { bank_id: selectedBrandId },
    { skip: !selectedBrandId }
  )

  return (
    <ConfigListShell
      brands={brands}
      selectedBrandId={selectedBrandId}
      onBrandChange={setSelectedBrandId}
    >
      {selectedBrandId ? (
        <RateflowTable
          data={rateflows ?? []}
          isFetching={isFetching}
          onSelect={id => navigate(`/config-admin/rateflow/${id}`)}
        />
      ) : null}
    </ConfigListShell>
  )
}

export default ConfigRateflow
